import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SuperAdminService } from '../../../services/super-admin/super-admin.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// create or edit a role. On edit the role key is immutable (matches the backend).
// data = { role } for edit, or null/undefined for create.
@Component({
  selector: 'app-sa-add-role-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, LoaderComponent],
  templateUrl: './sa-add-role-dialog.component.html',
  styleUrls: ['./sa-add-role-dialog.component.scss', '../../../../common-style/dropdown.scss', '../../../../common-style/ac-dialog.scss'],
})
export class SaAddRoleDialogComponent implements OnInit {
  form: FormGroup;
  isEdit: boolean = false;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<SaAddRoleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { role?: any },
    private superAdminService: SuperAdminService,
    private toastService: ToastService
  ) {
    this.form = this.fb.group({
      roleName: ['', Validators.required],
      roleKey: ['', Validators.required],
      rolePriority: [0, Validators.required],
      applicableFor: ['ESTABLISHMENT', Validators.required],
      scope: ['ESTABLISHMENT', Validators.required],
      grantsAllAccess: [false],
      status: [1],
    });
  }

  ngOnInit(): void {
    const role = this.data?.role;
    if (role) {
      this.isEdit = true;
      this.form.patchValue({
        roleName: role.roleName,
        roleKey: role.roleKey,
        rolePriority: role.rolePriority,
        applicableFor: role.applicableFor,
        scope: role.scope,
        grantsAllAccess: role.grantsAllAccess,
        status: role.status,
      });
      this.form.get('roleKey')?.disable(); // key is immutable on edit
    }
  }

  submit(): void {
    if (this.form.invalid) {
      this.toastService.error('Name, key, applicable-for and scope are required.');
      return;
    }
    this.isLoading = true;
    const payload = this.form.getRawValue(); // include disabled roleKey
    const role = this.data?.role;
    const request$ = this.isEdit
      ? this.superAdminService.updateRole(role.roleId, payload)
      : this.superAdminService.createRole(payload);
    request$.subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Saved.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to save role.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
